module.exports = __webpack_public_path__ + "static/WORLD0-28379c9898d4bb7958cbf402f7e143b6.jpg";